import Script from "next/script";

export const RumScript = () => {
    return (
        <Script
            id="rumScript"
            strategy="lazyOnload"
            src="https://cdn.impactcommerce.io/script/22bbdebc8d01285a04f3f1abd9e6a25c.js"
        ></Script>
    );
};
